import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Alert,
  Modal,
  Button,
  useTheme,
} from "@mui/material";
import { DataGrid, GridCloseIcon } from "@mui/x-data-grid";

export default function CsvPreviewModal({
  open,
  onClose,
  elementData = [],
  duplicatedRows = new Set(),
  importElements,
}) {
  const theme = useTheme();

  const styles = {
    modal: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 800,
      bgcolor: "background.default",
      boxShadow: 24,
      p: 4,
    },
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="import-csv-modal-title"
      aria-describedby="import-csv-modal-description"
    >
      <Box sx={styles.modal}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography id="import-csv-modal-title" variant="h6" component="h2">
            Preview CSV
          </Typography>
          <IconButton aria-label="close" onClick={onClose} size="small">
            <GridCloseIcon />
          </IconButton>
        </Box>

        {duplicatedRows.size > 0 && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            Existem linhas com Latitude e Longitude duplicadas
          </Alert>
        )}

        <Box sx={{ height: 350, width: "100%", mt: 2 }}>
          <DataGrid
            rows={elementData.map((row, idx) => ({ id: idx, ...row }))}
            columns={[
              { field: "titulo", headerName: "Título", flex: 1 },
              { field: "img", headerName: "Imagem", flex: 1 },
              { field: "hostname", headerName: "Hostname", flex: 1 },
              { field: "lat", headerName: "Latitude", flex: 1 },
              { field: "long", headerName: "Longitude", flex: 1 },
            ]}
            pageSize={5}
            rowsPerPageOptions={[5]}
            disableSelectionOnClick
            hideFooterSelectedRowCount
            getRowClassName={(params) =>
              duplicatedRows.has(params.id) ? "duplicated-row" : ""
            }
            sx={{
              "& .duplicated-row": {
                border: "2px solid",
                borderColor: theme.palette.error.main,
              },
            }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            mt: 3,
          }}
        >
          <Button variant="text" color="primary" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={duplicatedRows.size > 0}
            onClick={async () => {
              await importElements(elementData);
              onClose();
            }}
          >
            Importar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
